import { Injectable, signal } from '@angular/core';
import type { WorkbenchMode } from '../models/types';

@Injectable({ providedIn: 'root' })
export class WorkbenchStore {
  private static readonly COLLAPSED_KEY = 'ur-workbench.sidebar-collapsed';

  readonly mode = signal<WorkbenchMode>('copilot');
  readonly sidebarCollapsed = signal(this.loadCollapsed());
  readonly mobileNavOpen = signal(false);

  setMode(mode: WorkbenchMode): void {
    this.mode.set(mode);
  }

  toggleSidebar(): void {
    const next = !this.sidebarCollapsed();
    this.sidebarCollapsed.set(next);
    try {
      localStorage.setItem(WorkbenchStore.COLLAPSED_KEY, String(next));
    } catch {
      /* private browsing etc. */
    }
  }

  setMobileNav(open: boolean): void {
    this.mobileNavOpen.set(open);
  }

  private loadCollapsed(): boolean {
    try {
      return localStorage.getItem(WorkbenchStore.COLLAPSED_KEY) === 'true';
    } catch {
      return false;
    }
  }
}
